import * as OmnitureConstants from './PaymentsOmnitureConstants';
import { PAYMENT_INSTRUMENT, EMI_TYPE, PAYMENT_SECTIONS, PROVIDER, NETBANKING_TYPE } from 'pages/PaymentsPage/PaymentOptions/constants';
import { CORPORATE_NB } from 'pages/PaymentsPage/Analytics/PaymentsOmnitureConstants';
import { get, attempt, isEmpty } from 'lodash';
import { isEmi } from 'reducers/PaymentReducers/emiStateReducer';
import ExecutionEnvironment from 'fbjs/lib/ExecutionEnvironment';
import { WALLET_LINKED_STATUS } from 'typings/Payments/PaymentsTypes';
import { TWO_FACTOR_AUTHENTICATION_MESSAGE } from 'pages/Checkout/TwoFactorAuth/TwoFactorAuth';
function sendTrackPageEvent(params, pageType = OmnitureConstants.TRACK_LINK.VALUES.PAGE_TYPE_DEFAULT) {
    const pageName = OmnitureConstants.TRACK_LINK.VALUES.PAGE_NAME;
    if (ExecutionEnvironment.canUseDOM) {
        attempt(get(window, ['omniture', 'trackPageView']), pageType, pageName, params);
    }
}
function sendTrackLinkEvent(params, name = 'track_link') {
    params[OmnitureConstants.TRACK_LINK.PROPS.PAGE_NAME] = OmnitureConstants.TRACK_LINK.VALUES.PAGE_NAME;
    params[OmnitureConstants.TRACK_LINK.PROPS.PAGE_TYPE] = OmnitureConstants.TRACK_LINK.VALUES.PAGE_TYPE_DEFAULT;
    if (ExecutionEnvironment.canUseDOM) {
        attempt(get(window, ['omniture', 'trackLink']), params, `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${name}`);
    }
}
let paymentOptionsResponseCached = [];
// To be used for distinct payment instruments like COD, NET Banking, etc. NOT for Saved cards where Payment
// instrument is the same; in that case the <clicked>option.js has to pass the section in the call
function getSection(payment_instrument) {
    if (paymentOptionsResponseCached) {
        const match = paymentOptionsResponseCached.filter(option => {
            return option.payment_instrument === payment_instrument;
        });
        if (match.length) {
            return match[0].section;
        }
    }
    // default to others; backend didn't pass mandatory param - section?
    return PAYMENT_SECTIONS.OTHERS;
}
function getNebankingType(nbType) {
    if (!nbType)
        return '';
    if (nbType.toUpperCase() === NETBANKING_TYPE.CORPORATE.toUpperCase())
        return `${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${NETBANKING_TYPE.CORPORATE}`;
    if (nbType.toUpperCase() === NETBANKING_TYPE.RETAIL.toUpperCase())
        return `${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${NETBANKING_TYPE.RETAIL}`;
    return '';
}
export function trackPaymentOptionsPageEvent(paymentOptions, availableOffers, priceSummary, tlsVersion, isAdvancePaymentPage, tokenParams) {
    const tokenVersion = { tokenParams };
    if (isEmpty(paymentOptions)) {
        return;
    }
    paymentOptionsResponseCached = paymentOptions;
    const paymentOptionDetails = getPaymentOptionsDetails(paymentOptions);
    const options = {
        eVar1: OmnitureConstants.TRACK_LINK.VALUES.PAGE_TYPE_DEFAULT,
        prop1: OmnitureConstants.TRACK_LINK.VALUES.PAGE_TYPE_DEFAULT,
        [OmnitureConstants.CARD.PROPS.SAVED_CARDS_COUNT]: paymentOptionDetails.savedCardCount
    };
    const events = [];
    let pboWalletPreferredStatus = paymentOptionDetails.walletDetails;
    let preferredOptionCounts = `${OmnitureConstants.OPTIONS_PAGE.VALUES.PREFERRED_OPTION_COUNTS}${paymentOptionDetails.preferredCount}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}` +
        `${OmnitureConstants.OPTIONS_PAGE.VALUES.PPQC_OPTIONS}${paymentOptionDetails.ppqcCount}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}` +
        `${OmnitureConstants.OPTIONS_PAGE.VALUES.PPQC_WALLET}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${paymentOptionDetails.ppqcWallet}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}` +
        `${OmnitureConstants.OPTIONS_PAGE.VALUES.PPQC_CARD}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${paymentOptionDetails.ppqcCard}` +
        `${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}${OmnitureConstants.OPTIONS_PAGE.VALUES.PREFERRED_OPTION_COUNTS}${OmnitureConstants.MOBILE_WALLET_VALUES.WALLET_SHOWN}${paymentOptionDetails.preferredMobileWallets.count}`;
    const coinPrice = priceSummary.convertible_amount && priceSummary.convertible_amount.find(c => c.type === 'COIN');
    if (availableOffers && availableOffers.length > 0) {
        pboWalletPreferredStatus = `${pboWalletPreferredStatus}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}${OmnitureConstants.OPTIONS_PAGE.VALUES.OFFER_PBO_SHOWN}`;
    }
    if (paymentOptionDetails.isPreferredShown) {
        pboWalletPreferredStatus = `${pboWalletPreferredStatus}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}${OmnitureConstants.OPTIONS_PAGE.VALUES.IS_PREFERRED_SHOWN}`;
        options[OmnitureConstants.OPTIONS_PAGE.PROPS.PREFERRED_BANK_CODE] = `${PAYMENT_INSTRUMENT.PREFERRED_NET}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}${paymentOptionDetails.preferredBankCode}`;
    }
    if (paymentOptionDetails.ppqcCard) {
        pboWalletPreferredStatus = `${pboWalletPreferredStatus}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}${OmnitureConstants.OPTIONS_PAGE.VALUES.PPQC_CARD}`;
    }
    if (paymentOptionDetails.ppqcWallet) {
        pboWalletPreferredStatus = `${pboWalletPreferredStatus}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}${OmnitureConstants.OPTIONS_PAGE.VALUES.PPQC_WALLET}`;
    }
    if (paymentOptionDetails.isAdvancePayment) {
        pboWalletPreferredStatus = `${pboWalletPreferredStatus}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}${OmnitureConstants.OPTIONS_PAGE.VALUES.ADVANCE_PAYMENT_SHOWN}`;
    }
    if (tlsVersion) {
        pboWalletPreferredStatus = `${pboWalletPreferredStatus}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}${OmnitureConstants.OPTIONS_PAGE.VALUES.TLS_VERSION_PREFIX}${tlsVersion}`;
    }
    if (tokenVersion) {
        pboWalletPreferredStatus = `${pboWalletPreferredStatus}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}${OmnitureConstants.OPTIONS_PAGE.VALUES.TOKEN_VERSION_PREFIX}${tokenVersion}`;
    }
    const mobileWalletLinkState = paymentOptionDetails.preferredMobileWallets.linkState;
    if (mobileWalletLinkState) {
        pboWalletPreferredStatus = `${pboWalletPreferredStatus}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}${mobileWalletLinkState}`;
    }
    if (coinPrice && coinPrice.count) {
        events.push(`${OmnitureConstants.OPTIONS_PAGE.COINS_REDEEMED_COUNT}=${coinPrice.count}`);
    }
    if (paymentOptionDetails.isEgv2faRequired) {
        events.push(`${OmnitureConstants.OPTIONS_PAGE.EGV_2FA_REQUIRED}`);
    }
    let pageType = '';
    if (isAdvancePaymentPage) {
        pageType = OmnitureConstants.TRACK_LINK.VALUES.PAGE_TYPE_ADVANCE;
        options[OmnitureConstants.OPTIONS_PAGE.PROPS.PAGE_VIEW] =
            OmnitureConstants.OPTIONS_PAGE.VALUES.PAGE_VIEW_ADVANCE_PAYMENT;
    }
    else {
        pageType = OmnitureConstants.TRACK_LINK.VALUES.PAGE_TYPE_DEFAULT;
        options[OmnitureConstants.OPTIONS_PAGE.PROPS.PAGE_VIEW] = OmnitureConstants.OPTIONS_PAGE.VALUES.PAGE_VIEW_DEFAULT;
    }
    options[OmnitureConstants.OPTIONS_PAGE.PROPS.PREFERRED_OPTION_COUNT] = preferredOptionCounts;
    options[OmnitureConstants.OPTIONS_PAGE.PROPS.PBO_WALLET_PREFERRED_STATUS] = pboWalletPreferredStatus;
    options[OmnitureConstants.OPTIONS_PAGE.PROPS.DISABLED_PAYMENT_OPTIONS] = paymentOptionDetails.disabledOptions;
    options[OmnitureConstants.OPTIONS_PAGE.EVENTS] = events.join(',');
    sendTrackPageEvent(options, pageType);
}
function getPaymentOptionsDetails(paymentOptions) {
    const INITIAL_STATE = {
        walletDetails: '',
        savedCardCount: 0,
        disabledOptions: '',
        isPreferredShown: false,
        preferredBankCode: null,
        preferredCount: 0,
        ppqcCount: 0,
        ppqcUpiCount: 0,
        ppqcCard: 0,
        ppqcWallet: 0,
        isAdvancePayment: false,
        isEgv2faRequired: false,
        preferredMobileWallets: {
            count: 0
        }
    };
    return paymentOptions.reduce((paymentDetails, option) => {
        if (option.section === PAYMENT_SECTIONS.PREFERRED) {
            paymentDetails.preferredCount++;
            if (option.payment_instrument === PAYMENT_INSTRUMENT.WALLET) {
                paymentDetails.preferredMobileWallets.count++;
                const { app_code, link_status } = option;
                const finalLinkStatus = link_status === WALLET_LINKED_STATUS.NOT_LINKED
                    ? OmnitureConstants.MOBILE_WALLET_VALUES.UNLINK
                    : link_status.replace('_', '');
                const { linkState = '' } = paymentDetails.preferredMobileWallets;
                const { SEPARATOR_1, SEPARATOR_2, PREFERRED_OPTION_COUNTS } = OmnitureConstants.OPTIONS_PAGE.VALUES;
                paymentDetails.preferredMobileWallets.linkState = `${linkState}${linkState ? SEPARATOR_2 : ''}${PREFERRED_OPTION_COUNTS}${app_code}${SEPARATOR_1}${finalLinkStatus}`;
            }
        }
        if (option.provider === PROVIDER.PHONEPE) {
            paymentDetails.ppqcCount++;
            switch (option.payment_instrument) {
                case PAYMENT_INSTRUMENT.SAVED_CARD:
                    paymentDetails.ppqcCard++;
                    break;
                case PAYMENT_INSTRUMENT.PHONEPE_WALLET_2:
                    paymentDetails.ppqcWallet++;
                    break;
                default:
                    // BHIM UPI is not passed by fkpg to desktop UI as of now.
                    break;
            }
        }
        if (option.payment_instrument === PAYMENT_INSTRUMENT.CASH_DELIVERY && option.part_payment) {
            paymentDetails.isAdvancePayment = true;
        }
        if (option.payment_instrument === PAYMENT_INSTRUMENT.SAVED_CARD && option.provider === PROVIDER.FLIPKART) {
            paymentDetails.savedCardCount++;
        }
        if (option.payment_instrument === PAYMENT_INSTRUMENT.GIFT_CARD_WALLET) {
            paymentDetails.walletDetails = addToWalletDetailsString(paymentDetails.walletDetails, option, OmnitureConstants.OPTIONS_PAGE.VALUES.GIFT_CARD);
            if (get(option, 'authentication.auth_mode', '') === TWO_FACTOR_AUTHENTICATION_MESSAGE.TWO_FACTOR_AUTHENTICATION) {
                paymentDetails.isEgv2faRequired = true;
            }
        }
        if (option.applicable === false) {
            paymentDetails.disabledOptions = addPaymentInstrumentToString(paymentDetails.disabledOptions, option);
        }
        if (option.payment_instrument === PAYMENT_INSTRUMENT.PREFERRED_NET) {
            paymentDetails.isPreferredShown = true;
            paymentDetails.preferredBankCode = option.bank_code;
        }
        return paymentDetails;
    }, INITIAL_STATE);
}
function addToWalletDetailsString(walletString, option, name) {
    if (option.applicable === true) {
        if (walletString === '') {
            walletString = `${name}_applicable`;
        }
        else {
            walletString = walletString.concat(OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2, name, OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1, 'applicable');
        }
    }
    else {
        let message = null;
        if (walletString === '') {
            message = getPaymentOptionMessage(option);
            walletString = name.concat(OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1, message);
        }
        else {
            walletString = walletString.concat(OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2, name, OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1, message);
        }
    }
    return walletString;
}
function getPaymentOptionMessage(option) {
    const messages = get(option, 'messages', []);
    return messages
        .filter(item => item && item.message)
        .map((item) => item.message)
        .join('');
}
function addPaymentInstrumentToString(currentString, option) {
    const finalString = currentString === ''
        ? option.payment_instrument
        : currentString.concat(OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2, option.payment_instrument);
    return finalString;
}
export function trackProceedToCaptchaClick() {
    const codClickEvent = OmnitureConstants.OPTIONS_PAGE_PROCEED.VALUES[PAYMENT_INSTRUMENT.CASH_DELIVERY];
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${getSection(PAYMENT_INSTRUMENT.CASH_DELIVERY)}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${codClickEvent}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION_2]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${codClickEvent}`
    };
    sendTrackLinkEvent(params, OmnitureConstants.OPTIONS_PAGE_PROCEED.VALUES[PAYMENT_INSTRUMENT.CASH_DELIVERY]);
}
export function trackCardClick({ paymentInstrument, isEMISelected, isGiftCardSelected, provider, section }) {
    const cardInstrument = OmnitureConstants.getInstrumentValue(paymentInstrument, provider);
    const cardClickEvent = isEMISelected
        ? `${OmnitureConstants.CARD.VALUES.CARD_SELECT}${OmnitureConstants.CARD.VALUES.FOR_EMI}`
        : cardInstrument;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${section || getSection(PAYMENT_INSTRUMENT.CREDIT_CARD)}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${cardInstrument}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION_2]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${cardInstrument}`
    };
    if (isEMISelected) {
        params[OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION] += OmnitureConstants.CARD.VALUES.FOR_EMI;
        params[OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION_2] += OmnitureConstants.CARD.VALUES.FOR_EMI;
    }
    if (isGiftCardSelected) {
        params[OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION] +=
            OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1 + OmnitureConstants.CARD.VALUES.GIFT_CARD;
        params[OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION_2] +=
            OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1 + OmnitureConstants.CARD.VALUES.GIFT_CARD;
    }
    sendTrackLinkEvent(params, cardClickEvent);
}
export const trackUPIClick = ({ section, paymentInstrument }) => {
    const instrument = OmnitureConstants.getInstrumentValue(paymentInstrument, null);
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${section || getSection(PAYMENT_INSTRUMENT.UPI)}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${instrument}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION_2]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${instrument}`
    };
    sendTrackLinkEvent(params, instrument);
};
export const trackUPIOptionClick = ({ section, paymentInstrument }) => {
    const instrument = OmnitureConstants.getInstrumentValue(paymentInstrument, null);
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${section || getSection(paymentInstrument)}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${instrument}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION_2]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${instrument}`
    };
    sendTrackLinkEvent(params, instrument);
};
export const trackUPIOptionProceedClick = ({ paymentInstrument }) => {
    const instrument = OmnitureConstants.getInstrumentValue(paymentInstrument, null);
    const linkName = `${instrument}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.OPTIONS_PAGE.VALUES.PROCEED}`;
    const paymentProceed = `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${linkName}`;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: paymentProceed,
        [OmnitureConstants.CUSTOM_LINK_PROPS.SELECTED_OPTION]: paymentProceed
    };
    sendTrackLinkEvent(params, linkName);
};
export const trackUPICollectOptionProceedClick = ({ rootPaymentInstrument, paymentInstrument }) => {
    const instrument = OmnitureConstants.getInstrumentValue(paymentInstrument, null);
    const linkName = `${instrument}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.OPTIONS_PAGE.VALUES.PROCEED}`;
    const paymentProceed = `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${linkName}`;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: `${OmnitureConstants.getInstrumentValue(rootPaymentInstrument, null)}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}${OmnitureConstants.getInstrumentValue(paymentInstrument, null)}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS.SELECTED_OPTION]: paymentProceed
    };
    sendTrackLinkEvent(params, linkName);
};
export const trackUPIIdVerifySuccess = ({ paymentInstrument }) => {
    const customLinkName = `${paymentInstrument}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.UPI_VALUES.FLOW_VERIFY}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.UPI_VALUES.SUCCESS}`;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: customLinkName
    };
    sendTrackLinkEvent(params, customLinkName);
};
export const trackUPIIdVerifyFailure = ({ paymentInstrument }) => {
    const customLinkName = `${paymentInstrument}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.UPI_VALUES.FLOW_VERIFY}`;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION]: `${customLinkName}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.UPI_VALUES.WRONG_ID}`
    };
    sendTrackLinkEvent(params, `${customLinkName}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.UPI_VALUES.FAILURE}`);
};
export const trackUPIPollFailure = ({ paymentInstrument }) => {
    const instrument = OmnitureConstants.getInstrumentValue(paymentInstrument, null);
    const customLinkName = `${instrument}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.UPI_VALUES.FAILED}`;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: customLinkName
    };
    sendTrackLinkEvent(params, customLinkName);
};
export function trackUPICancelPaymentAndGoBack({ rootPaymentInstrument }) {
    const customLinkName = `${rootPaymentInstrument}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.UPI_VALUES.GO_BACK}`;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: customLinkName
    };
    sendTrackLinkEvent(params, customLinkName);
}
export function trackPPQCWalletClick({ paymentInstrument, isGiftCardSelected, section }) {
    const cardInstrument = OmnitureConstants.OPTIONS_PAGE_PROCEED.VALUES[paymentInstrument];
    const cardClickEvent = cardInstrument;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${section}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${cardInstrument}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION_2]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${cardInstrument}`
    };
    if (isGiftCardSelected) {
        params[OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION] +=
            OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1 + OmnitureConstants.CARD.VALUES.GIFT_CARD;
        params[OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION_2] +=
            OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1 + OmnitureConstants.CARD.VALUES.GIFT_CARD;
    }
    sendTrackLinkEvent(params, cardClickEvent);
}
export function trackCardNumberEntered(isInternationalCard) {
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: OmnitureConstants.CARD.VALUES.CARD_NUMBER_ENTERED
    };
    if (isInternationalCard) {
        params[OmnitureConstants.CARD.PROPS.BILLING_ADDRESS_REQUIRED] =
            OmnitureConstants.CARD.VALUES.BILLING_ADDRESS_REQUIRED;
    }
    sendTrackLinkEvent(params);
}
export function trackWrongCardNumberEntered() {
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: OmnitureConstants.CARD.VALUES.WRONG_CARD_NUMBER
    };
    sendTrackLinkEvent(params);
}
export function trackMoreInfoClick() {
    const moreInfoClickEvent = `${OmnitureConstants.OPTIONS_PAGE_PROCEED.VALUES[PAYMENT_INSTRUMENT.CREDIT_CARD]}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.CARD.VALUES.MORE_INFO_CLICKED}`;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${moreInfoClickEvent}`
    };
    sendTrackLinkEvent(params, moreInfoClickEvent);
}
export function trackProceedToNetBankingClick(isGiftCardSelected, nb_type) {
    const netBankingInstrument = OmnitureConstants.OPTIONS_PAGE_PROCEED.VALUES[PAYMENT_INSTRUMENT.NETBANKING];
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${getSection(PAYMENT_INSTRUMENT.NETBANKING)}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${netBankingInstrument}${getNebankingType(nb_type)}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION_2]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${netBankingInstrument}`
    };
    if (isGiftCardSelected) {
        params[OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION] += `${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.CARD.VALUES.GIFT_CARD}`;
        params[OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION_2] += `${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.CARD.VALUES.GIFT_CARD}`;
    }
    sendTrackLinkEvent(params, netBankingInstrument);
}
export function trackProceedToPreferredClick(isGiftCardSelected) {
    const preferredInstrument = OmnitureConstants.OPTIONS_PAGE_PROCEED.VALUES[PAYMENT_INSTRUMENT.PREFERRED_NET];
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${preferredInstrument}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION_2]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${preferredInstrument}`
    };
    if (isGiftCardSelected) {
        params[OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION] += `${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.CARD.VALUES.GIFT_CARD}`;
        params[OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION_2] += `${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.CARD.VALUES.GIFT_CARD}`;
    }
    sendTrackLinkEvent(params, preferredInstrument);
}
export function trackProceedToEMIClick({ typesOfBanks, disabledBanks }) {
    const emiInstrument = OmnitureConstants.OPTIONS_PAGE_PROCEED.VALUES[PAYMENT_INSTRUMENT.EMI];
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${getSection(PAYMENT_INSTRUMENT.EMI)}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${emiInstrument}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION_2]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${emiInstrument}`,
        [OmnitureConstants.EMI_OPTIONS_PAGE.PROPS
            .TYPES_OF_EMI_OPTIONS_SHOWN]: `${typesOfBanks}${OmnitureConstants.EMI_OPTIONS_PAGE.VALUES.EMI_OPTIONS_SHOWN}`
    };
    if (disabledBanks) {
        params[OmnitureConstants.EMI_OPTIONS_PAGE.PROPS.EMI_BANK_DISABLED] = disabledBanks;
    }
    sendTrackLinkEvent(params, emiInstrument);
}
export function trackEMITypeSelection(emiType) {
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: OmnitureConstants.EMI_OPTIONS_PAGE.VALUES[emiType],
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION_2]: OmnitureConstants.EMI_OPTIONS_PAGE.VALUES[emiType]
    };
    sendTrackLinkEvent(params);
}
export function trackEMITermsClick() {
    const emiTermsClickEvent = OmnitureConstants.EMI_OPTIONS_PAGE.VALUES.TNC_CLICKED;
    const params = {
        [OmnitureConstants.EMI_OPTIONS_PAGE.PROPS
            .TNC_CLICKED]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${emiTermsClickEvent}`
    };
    sendTrackLinkEvent(params, emiTermsClickEvent);
}
export function trackItemBreakupClicked() {
    const params = {
        [OmnitureConstants.EMI_OPTIONS_PAGE.PROPS.ITEM_BREAKUP_CLICKED]: OmnitureConstants.EMI_OPTIONS_PAGE.VALUES.ITEM_BREAKUP_CLICKED
    };
    sendTrackLinkEvent(params);
}
export function trackChooseThisPlanClick(trackingParams) {
    const chooseThisPlanEvent = OmnitureConstants.EMI_OPTIONS_PAGE.VALUES.CHOOSE_THIS_PLAN;
    const events = `${OmnitureConstants.EMI_OPTIONS_PAGE.PROPS.CART_ITEM_COUNT}=${trackingParams.cartItemCount}`;
    const params = {
        [OmnitureConstants.EMI_OPTIONS_PAGE.PROPS
            .CHOOSE_THIS_PLAN]: `${trackingParams.bankCode}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}${trackingParams.tenure}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}${trackingParams.selectedSection}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION]: `${OmnitureConstants.EMI_OPTIONS_PAGE.VALUES.EMI_TENURE_SELECTION}_${trackingParams.selectedSection}_selected`,
        [OmnitureConstants.EMI_OPTIONS_PAGE.PROPS.EVENTS]: events,
        [OmnitureConstants.EMI_OPTIONS_PAGE.PROPS.NO_COST_ITEM_COUNT]: trackingParams.noCostItemCount.toString(),
        [OmnitureConstants.EMI_OPTIONS_PAGE.PROPS.EMI_SAVED_CARD_COUNT]: trackingParams.emiSavedCardCount.toString()
    };
    sendTrackLinkEvent(params, chooseThisPlanEvent);
}
export function trackAddEgvClick() {
    let addEgvEvent = OmnitureConstants.OPTIONS_PAGE.VALUES.EGV_ADD_CLICKED;
    const params = {
        [OmnitureConstants.OPTIONS_PAGE.PROPS.EGV_ADD_CLICKED]: addEgvEvent
    };
    sendTrackLinkEvent(params, addEgvEvent);
}
export function trackAdvancePaymentDetailsClick() {
    const eventValue = OmnitureConstants.OPTIONS_PAGE.VALUES.ADVANCE_PAYMENT_DETAILS_CLICKED;
    const params = {
        [OmnitureConstants.OPTIONS_PAGE.PROPS.ADVANCE_PAYMENT_DETAILS_CLICKED]: eventValue
    };
    sendTrackLinkEvent(params, eventValue);
}
export function trackCODAdvancePayNow() {
    const codInstrument = OmnitureConstants.OPTIONS_PAGE_PROCEED.VALUES[PAYMENT_INSTRUMENT.CASH_DELIVERY];
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${getSection(PAYMENT_INSTRUMENT.CASH_DELIVERY)}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${codInstrument}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION_2]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${OmnitureConstants.OPTIONS_PAGE.VALUES.COD_ADVANCE_PAY_NOW}`
    };
    sendTrackLinkEvent(params, codInstrument);
}
export function trackCODProceed(isSuccess, isGiftCardSelected) {
    let codProceedEvent = OmnitureConstants.OPTIONS_PAGE.VALUES.COD_PROCEED_CLICK;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.SELECTED_OPTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${OmnitureConstants.OPTIONS_PAGE_PROCEED.VALUES[PAYMENT_INSTRUMENT.CASH_DELIVERY]}`
    };
    params[OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION] = `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${codProceedEvent}${isSuccess
        ? OmnitureConstants.OPTIONS_PAGE.VALUES.RIGHT_CAPTCHA
        : OmnitureConstants.OPTIONS_PAGE.VALUES.WRONG_CAPTCHA}`;
    if (isGiftCardSelected) {
        params[OmnitureConstants.CUSTOM_LINK_PROPS.SELECTED_OPTION] += `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${OmnitureConstants.CARD.VALUES.GIFT_CARD}`;
    }
    sendTrackLinkEvent(params, codProceedEvent);
}
export function trackProceedWithCard(trackingParams) {
    trackingParams.payment_instrument = isEmi(trackingParams.emiState)
        ? PAYMENT_INSTRUMENT.EMI
        : trackingParams.payment_instrument;
    const cardValue = OmnitureConstants.getInstrumentValue(trackingParams.payment_instrument, trackingParams.provider);
    const cardProceedEvent = `${cardValue}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.OPTIONS_PAGE.VALUES.PROCEED}`;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT + cardProceedEvent,
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .SELECTION_DETAILS]: `${trackingParams.bank_code}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}${trackingParams.card_type}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .SELECTED_OPTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${cardProceedEvent}`
    };
    if (trackingParams.auth_mode) {
        params[OmnitureConstants.CUSTOM_LINK_PROPS.SELECTION_DETAILS] += `${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}${trackingParams.auth_mode}`;
    }
    if (trackingParams.trackIsOfferApplied) {
        params[OmnitureConstants.CUSTOM_LINK_PROPS.OFFER_APPLIED] = OmnitureConstants.OPTIONS_PAGE.VALUES.OFFER_APPLIED;
    }
    if (isEmi(trackingParams.emiState)) {
        params[OmnitureConstants.CUSTOM_LINK_PROPS.SELECTION_DETAILS] += `${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}${trackingParams.emiState.selectedSection}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}${trackingParams.emiState.selectedTenure}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}${trackingParams.payment_instrument}`;
        params[OmnitureConstants.CUSTOM_LINK_PROPS.SELECTED_OPTION] =
            OmnitureConstants.EMI_OPTIONS_PAGE.VALUES[trackingParams.emiState.selectedSection];
    }
    if (trackingParams.isGiftCardSelected) {
        params[OmnitureConstants.CUSTOM_LINK_PROPS.SELECTED_OPTION] += `${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.CARD.VALUES.GIFT_CARD}`;
    }
    sendTrackLinkEvent(params, cardProceedEvent);
}
export function trackNetBankingProceed(trackingParams, nb_type) {
    const netBankingProceedEvent = `${OmnitureConstants.OPTIONS_PAGE_PROCEED.VALUES[PAYMENT_INSTRUMENT.NETBANKING]}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.OPTIONS_PAGE.VALUES.PROCEED}`;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${netBankingProceedEvent}${getNebankingType(nb_type)}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .SELECTION_DETAILS]: `${trackingParams.payment_instrument}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_2}${trackingParams.bank_code}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS.SELECTED_OPTION]: trackingParams.isPopularBank
            ? `${OmnitureConstants.OPTIONS_PAGE.VALUES.NET_BANKING_POPULAR_BANK}${getNebankingType(nb_type)}`
            : `${OmnitureConstants.OPTIONS_PAGE.VALUES.NET_BANKING_OTHER_BANK}${getNebankingType(nb_type)}`
    };
    if (trackingParams.isGiftCardSelected) {
        params[OmnitureConstants.CUSTOM_LINK_PROPS.SELECTED_OPTION] += `${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.OPTIONS_PAGE.VALUES.GIFT_CARD}`;
    }
    sendTrackLinkEvent(params, netBankingProceedEvent);
}
export function trackCorporateNetBankingOnload() {
    sendTrackLinkEvent({ [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: CORPORATE_NB.CNB_SHOWN }, CORPORATE_NB.CNB_SHOWN);
}
export function trackInfoLinkClicked({ payment_instrument, provider }) {
    const infoLinkClickEvent = `${OmnitureConstants.getInstrumentValue(payment_instrument, provider)}${OmnitureConstants.OPTIONS_PAGE.VALUES.INFO_LINK_KNOW_MORE}`;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${infoLinkClickEvent}`
    };
    sendTrackLinkEvent(params, infoLinkClickEvent);
}
export function trackPPQCWalletProceed(trackingParams) {
    const ppqcWalletEvent = `${OmnitureConstants.OPTIONS_PAGE_PROCEED.VALUES[PAYMENT_INSTRUMENT.PHONEPE_WALLET_2]}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.OPTIONS_PAGE.VALUES.PROCEED}`;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${ppqcWalletEvent}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION_2]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${ppqcWalletEvent}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS.SELECTED_OPTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${OmnitureConstants.OPTIONS_PAGE_PROCEED.VALUES[PAYMENT_INSTRUMENT.PHONEPE_WALLET_2]}`
    };
    if (trackingParams.isGiftCardSelected) {
        params[OmnitureConstants.CUSTOM_LINK_PROPS.SELECTED_OPTION] += `${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.OPTIONS_PAGE.VALUES.GIFT_CARD}`;
    }
    sendTrackLinkEvent(params, ppqcWalletEvent);
}
export function trackPreferredNetProceed(trackingParams) {
    const preferredNetEvent = `${OmnitureConstants.OPTIONS_PAGE_PROCEED.VALUES[PAYMENT_INSTRUMENT.PREFERRED_NET]}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.OPTIONS_PAGE.VALUES.PROCEED}`;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${preferredNetEvent}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION_2]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${preferredNetEvent}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS.SELECTED_OPTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${OmnitureConstants.OPTIONS_PAGE_PROCEED.VALUES[PAYMENT_INSTRUMENT.PREFERRED_NET]}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS.SELECTION_DETAILS]: `${OmnitureConstants.OPTIONS_PAGE_PROCEED.VALUES[PAYMENT_INSTRUMENT.PREFERRED_NET]}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${trackingParams.bank_code}`
    };
    if (trackingParams.isGiftCardSelected) {
        params[OmnitureConstants.CUSTOM_LINK_PROPS.SELECTED_OPTION] += `${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.OPTIONS_PAGE.VALUES.GIFT_CARD}`;
    }
    sendTrackLinkEvent(params, preferredNetEvent);
}
export function trackOfferWidgetTncClick() {
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${OmnitureConstants.OPTIONS_PAGE.VALUES.OFFER_WIDGET_TNC_CLICK}`
    };
    sendTrackLinkEvent(params, OmnitureConstants.OPTIONS_PAGE.VALUES.OFFER_WIDGET_TNC_CLICK);
}
export function trackChooseAnotherPlanClick() {
    const chooseAnotherPlanClickEvent = OmnitureConstants.EMI_OPTIONS_PAGE.VALUES.CHOOSE_ANOTHER_PLAN;
    const params = {
        [OmnitureConstants.EMI_OPTIONS_PAGE.PROPS
            .CHOOSE_ANOTHER_PLAN]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${chooseAnotherPlanClickEvent}`
    };
    sendTrackLinkEvent(params, chooseAnotherPlanClickEvent);
}
export function trackGiftCardAddSuccess() {
    const giftCardSuccessEvent = OmnitureConstants.OPTIONS_PAGE.VALUES.EGV_APPLIED_SUCCESS;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${giftCardSuccessEvent}`
    };
    sendTrackLinkEvent(params, giftCardSuccessEvent);
}
export function trackEMIBankSelect(trackingParams) {
    const bankSelectEvent = `${OmnitureConstants.EMI_OPTIONS_PAGE.VALUES.EMI_OPTION}${trackingParams.sectionCode}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${trackingParams.bankCode}`;
    const events = `${OmnitureConstants.EMI_OPTIONS_PAGE.PROPS.CART_ITEM_COUNT}=${trackingParams.cartItemCount}`;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: bankSelectEvent,
        [OmnitureConstants.CUSTOM_LINK_PROPS.SELECTION_DETAILS]: trackingParams.bankCode,
        [OmnitureConstants.EMI_OPTIONS_PAGE.PROPS.EVENTS]: events,
        [OmnitureConstants.EMI_OPTIONS_PAGE.PROPS.NO_COST_ITEM_COUNT]: trackingParams.maxNoCostCount.toString()
    };
    sendTrackLinkEvent(params, bankSelectEvent);
}
export function trackProceedWithWallet() {
    const walletProceedEvent = OmnitureConstants.OPTIONS_PAGE.VALUES.GIFT_CARD +
        OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1 +
        OmnitureConstants.OPTIONS_PAGE.VALUES.PROCEED;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT + walletProceedEvent,
        [OmnitureConstants.CUSTOM_LINK_PROPS.SELECTED_OPTION]: OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT + walletProceedEvent
    };
    sendTrackLinkEvent(params, walletProceedEvent);
}
export function trackOTPPromptVisible() {
    const params = {
        [OmnitureConstants.OTP.PROPS.OTP_EVENT]: OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT + OmnitureConstants.OTP.VALUES.OTP_PROMPT_VISIBLE
    };
    sendTrackLinkEvent(params, OmnitureConstants.OTP.VALUES.OTP_PROMPT_VISIBLE);
}
export function trackOTPRetryNudge(otpAttemptsLeft) {
    const params = {
        [OmnitureConstants.OTP.PROPS.OTP_EVENT]: OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT + OmnitureConstants.OTP.VALUES.OTP_RETRY_NUDGE,
        [OmnitureConstants.OTP.PROPS.OTP_ATTEMPTS_LEFT]: otpAttemptsLeft
    };
    sendTrackLinkEvent(params, OmnitureConstants.OTP.VALUES.OTP_RETRY_NUDGE);
}
export function trackResendOTPClick() {
    const params = {
        [OmnitureConstants.OTP.PROPS.OTP_EVENT]: OmnitureConstants.OTP.VALUES.RESEND_OTP_CLICKED
    };
    sendTrackLinkEvent(params, OmnitureConstants.OTP.VALUES.RESEND_OTP_CLICKED);
}
export function trackFallbackOTPClick() {
    const params = {
        [OmnitureConstants.OTP.PROPS.OTP_EVENT]: OmnitureConstants.OTP.VALUES.OTP_FALLBACK_MODE_CLICKED
    };
    sendTrackLinkEvent(params, OmnitureConstants.OTP.VALUES.OTP_FALLBACK_MODE_CLICKED);
}
export function trackGoBackClick() {
    const params = {
        [OmnitureConstants.OTP.PROPS.OTP_EVENT]: OmnitureConstants.OTP.VALUES.OTP_CLICK_HERE_TO_GO_BACK
    };
    sendTrackLinkEvent(params, OmnitureConstants.OTP.VALUES.OTP_CLICK_HERE_TO_GO_BACK);
}
export function trackPhonePeClick() {
    const phonePeInstrument = OmnitureConstants.OPTIONS_PAGE_PROCEED.VALUES[PAYMENT_INSTRUMENT.PHONEPE_UPI];
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${getSection(PAYMENT_INSTRUMENT.PHONEPE_UPI)}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${phonePeInstrument}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION_2]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${phonePeInstrument}`
    };
    sendTrackLinkEvent(params, phonePeInstrument);
}
export function trackPhonePeProceed() {
    const phonePeInstrument = `${OmnitureConstants.OPTIONS_PAGE_PROCEED.VALUES[PAYMENT_INSTRUMENT.PHONEPE_UPI]}${OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1}${OmnitureConstants.OPTIONS_PAGE.VALUES.PROCEED}`;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT + phonePeInstrument,
        [OmnitureConstants.CUSTOM_LINK_PROPS.SELECTED_OPTION]: OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT + phonePeInstrument
    };
    sendTrackLinkEvent(params, phonePeInstrument);
}
export function trackTenuresOnSavedCardsShown(emiCount) {
    const { nce, nonNce } = emiCount;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: OmnitureConstants.EMI_ON_SAVED_CARDS.PAY_VIA_EMI,
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION_2]: OmnitureConstants.EMI_ON_SAVED_CARDS.PAY_VIA_EMI_PM,
        [OmnitureConstants.CUSTOM_LINK_PROPS.DISCOUNT]: `NCEMI_${nce}_EMIwithI_${nonNce}`
    };
    sendTrackLinkEvent(params);
}
export function trackFullPaymentMode() {
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: OmnitureConstants.EMI_ON_SAVED_CARDS.PAY_FULL,
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION_2]: OmnitureConstants.EMI_ON_SAVED_CARDS.PAY_FULL_PM
    };
    sendTrackLinkEvent(params);
}
export function trackEMISummaryShown(emiType) {
    let stringToSend = '';
    switch (emiType) {
        case EMI_TYPE.NO_COST:
            stringToSend = 'No_cost_EMI_box';
            break;
        case EMI_TYPE.PRE_APPROVED:
            stringToSend = 'Pre_approved_EMI_box';
            break;
        case EMI_TYPE.INTEREST:
            stringToSend = 'Interest_EMI_box';
            break;
        default:
        // noop
    }
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: OmnitureConstants.EMI_ON_SAVED_CARDS.SUMMARY_SHOWN,
        [OmnitureConstants.CUSTOM_LINK_PROPS.SELECTED_OPTION]: stringToSend
    };
    sendTrackLinkEvent(params);
}
export function trackEMIOnSavedCardsShown(discountShown) {
    const stringToSend = discountShown ? 'discount_shown' : 'not_shown';
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: OmnitureConstants.EMI_ON_SAVED_CARDS.EMI_OPTION_SHOWN,
        [OmnitureConstants.CUSTOM_LINK_PROPS.DISCOUNT]: stringToSend
    };
    sendTrackLinkEvent(params);
}
export function trackBnplShown(paymentInstrument) {
    const stringToSend = `Payment_${OmnitureConstants.OPTIONS_PAGE_PROCEED.VALUES[paymentInstrument]}`;
    sendTrackLinkEvent({
        [OmnitureConstants.OPTIONS_PAGE_PROCEED.PROPS.SELECTED_OPTION]: stringToSend,
        [OmnitureConstants.OPTIONS_PAGE_PROCEED.PROPS.NEW_SELECTED_OPTION]: stringToSend
    });
}
export function trackBnplContinueClick(paymentInstrument) {
    const stringToSend = `Payment_${OmnitureConstants.OPTIONS_PAGE_PROCEED.VALUES[paymentInstrument]}_proceed`;
    sendTrackLinkEvent({
        [OmnitureConstants.CUSTOM_LINK_PROPS.SELECTED_OPTION]: stringToSend,
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: stringToSend
    });
}
export function trackWalletOptionClick(wallets, paymentInstrument, totalWallets) {
    const [linked, unlinked, expired] = wallets;
    const instrument = OmnitureConstants.getInstrumentValue(paymentInstrument, null);
    const separator = OmnitureConstants.MOBILE_WALLET_VALUES.SEPARATOR;
    const separator_1 = OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1;
    const walletAppNamesByStatus = [];
    if (linked.length) {
        walletAppNamesByStatus.push(`Linked${separator_1}${linked.join(separator_1)}`);
    }
    if (unlinked.length) {
        walletAppNamesByStatus.push(`Unlinked${separator_1}${unlinked.join(separator_1)}`);
    }
    if (expired.length) {
        walletAppNamesByStatus.push(`LinkExpired${separator_1}${expired.join(separator_1)}`);
    }
    const section = PAYMENT_SECTIONS.OTHERS;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${section}${separator_1}${instrument}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION_2]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${instrument}`,
        [OmnitureConstants.MOBILE_WALLET_PROPS
            .WALLETS_STATUS_WITH_COUNT]: `WS${separator_1}${totalWallets}${separator}LD${separator_1}${linked.length}${separator}ULK${separator_1}${unlinked.length}${separator}LE${separator_1}${expired.length}`,
        [OmnitureConstants.MOBILE_WALLET_PROPS.WALLETS_PROP23]: walletAppNamesByStatus.join(separator)
    };
    sendTrackLinkEvent(params, instrument);
}
export function trackWalletSelection(walletName, section) {
    const separator_1 = OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1;
    const eventName = `${OmnitureConstants.MOBILE_WALLET_VALUES.WALLET}${separator_1}${walletName}pm`;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION]: `${OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT}${section}${separator_1}${OmnitureConstants.MOBILE_WALLET_VALUES.WALLET}${separator_1}${walletName}pm`,
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION_2]: OmnitureConstants.OPTIONS_PAGE.VALUES.PAYMENT + eventName
    };
    sendTrackLinkEvent(params, eventName);
}
export function trackWalletOtpGenerate(walletName, linkStatus, section, errorMessage) {
    const { WALLET, LINK_NOW, OTP_PAGE, ERROR, CLICKED, UNLINK } = OmnitureConstants.MOBILE_WALLET_VALUES;
    const separator_1 = OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1;
    const walletLinkNowText = `${WALLET}${separator_1}${LINK_NOW}${separator_1}${CLICKED}${separator_1}${walletName}`;
    const formattedLinkStatus = linkStatus === WALLET_LINKED_STATUS.NOT_LINKED ? UNLINK : linkStatus.replace('_', '');
    const eventName = errorMessage
        ? `${walletLinkNowText}${separator_1}${ERROR}`
        : `${walletLinkNowText}${separator_1}${OTP_PAGE}`;
    const walletState = errorMessage
        ? `${section}${separator_1}${LINK_NOW}${separator_1}${ERROR}${separator_1}${walletName}${separator_1}${errorMessage}`
        : `${section}${separator_1}${walletLinkNowText}${separator_1}${formattedLinkStatus}${separator_1}${OTP_PAGE}`;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: walletState
    };
    sendTrackLinkEvent(params, eventName);
}
export function trackWalletLinked(walleName, section) {
    const { WALLET, LINKED, SUCCESSFUL } = OmnitureConstants.MOBILE_WALLET_VALUES;
    const separator_1 = OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1;
    const eventName = `${WALLET}${separator_1}${LINKED}${separator_1}${walleName}${separator_1}${SUCCESSFUL}`;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: `${section}${separator_1}${walleName}${separator_1}${LINKED}`,
        [OmnitureConstants.OPTIONS_PAGE.EVENTS]: `${OmnitureConstants.MOBILE_WALLET_PROPS.WALLET_EVENT}=1`
    };
    sendTrackLinkEvent(params, eventName);
}
export function trackWalletOtpValidateError(walletName, section, errorMessage) {
    const { WALLET, LINK, OTP_ERROR } = OmnitureConstants.MOBILE_WALLET_VALUES;
    const separator_1 = OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1;
    const eventName = `${WALLET}${separator_1}${LINK}${separator_1}${walletName}${separator_1}${OTP_ERROR}`;
    const walletState = `${section}${separator_1}${LINK}${separator_1}${OTP_ERROR}${separator_1}${walletName}${separator_1}${errorMessage}`;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: walletState
    };
    sendTrackLinkEvent(params, eventName);
}
function getBalanceTrackMessage(balance, amountPayable) {
    const { SUFFICIENT_BALANCE, INSUFFICIENT_BALANCE, BALANCE_LOAD_FAILED } = OmnitureConstants.MOBILE_WALLET_VALUES;
    const parsedBalance = Number(balance);
    return isNaN(parsedBalance)
        ? BALANCE_LOAD_FAILED
        : parsedBalance < amountPayable
            ? INSUFFICIENT_BALANCE
            : SUFFICIENT_BALANCE;
}
export function trackWalletBalance(walletName, section, balance, amountPayable) {
    const { WALLET, BALANCE, LINKED } = OmnitureConstants.MOBILE_WALLET_VALUES;
    const separator_1 = OmnitureConstants.OPTIONS_PAGE.VALUES.SEPARATOR_1;
    const balanceMessage = getBalanceTrackMessage(balance, amountPayable);
    const eventName = `${WALLET}${separator_1}${BALANCE}${separator_1}${LINKED}${separator_1}${walletName}${separator_1}${balanceMessage}`;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.USER_ACTION]: `${section}${separator_1}${eventName}`
    };
    sendTrackLinkEvent(params, eventName);
}
export function trackWalletPayClick(walletName, section, balance, amountPayable) {
    const { WALLET_PM, CONTINUE } = OmnitureConstants.MOBILE_WALLET_VALUES;
    const { SEPARATOR_1, SEPARATOR_2, PROCEED, PAYMENT } = OmnitureConstants.OPTIONS_PAGE.VALUES;
    const balanceMessage = getBalanceTrackMessage(balance, amountPayable);
    const eventName = `${WALLET_PM}${SEPARATOR_1}${walletName}${SEPARATOR_1}${PROCEED}`;
    const params = {
        [OmnitureConstants.CUSTOM_LINK_PROPS.SELECTED_OPTION]: `${PAYMENT}${WALLET_PM}${SEPARATOR_2}${walletName}`,
        [OmnitureConstants.CUSTOM_LINK_PROPS
            .USER_ACTION]: `${PAYMENT}${section}${SEPARATOR_1}${WALLET_PM}${SEPARATOR_2}${walletName}${SEPARATOR_1}${balanceMessage}${SEPARATOR_1}${CONTINUE}`
    };
    sendTrackLinkEvent(params, eventName);
}
export function trackWalletOfferClick(section) {
    const { DETAILS_CLICK, WALLET } = OmnitureConstants.MOBILE_WALLET_VALUES;
    const { SEPARATOR_1 } = OmnitureConstants.OPTIONS_PAGE.VALUES;
    const eventName = `${WALLET}s${SEPARATOR_1}${DETAILS_CLICK}`;
    const params = {
        [OmnitureConstants.MOBILE_WALLET_PROPS
            .WALLETS_PROP23]: `${WALLET}s${SEPARATOR_1}${section}${SEPARATOR_1}${DETAILS_CLICK}`
    };
    sendTrackLinkEvent(params, eventName);
}
